import TencentCloudChat from '@tencentcloud/chat'
import { getData } from '@/api/user/authApi'

let timInstance = null
let loginPromise = null
let isLogin = false
const SDK_APP_ID = 1400539979

/** 获取/创建 TIM 单例 */
export function getTIM() {
  if (!timInstance) {
    timInstance = TencentCloudChat.create({ SDKAppID: SDK_APP_ID })
    timInstance.setLogLevel(1) // 生产环境建议改为 4
  }
  return timInstance
}

/** 登录 TIM（单例，重复调用不会重复登录） */
export function loginTIM(userId) {
  const tim = getTIM()
  if (isLogin) return Promise.resolve(tim)
  if (loginPromise) return loginPromise

  loginPromise = new Promise((resolve, reject) => {
    // 与项目其他 getData 调用保持一致（url, method, params）
    getData('base/user/user/user/get/getUserSig', 'get', { baseUserId: userId })
      .then(res => {
        const userSig = res.data?.userSig || res.data?.data?.userSig
        if (!userSig) throw new Error('后端未返回 userSig')
        return tim.login({ userID: String(userId), userSig })
      })
      .then(() => {
        isLogin = true
        loginPromise = null
        console.log('[TIM] 登录成功', userId)
        resolve(tim)
      })
      .catch(err => {
        console.error('[TIM] 登录失败', err)
        loginPromise = null
        isLogin = false
        reject(err)
      })
  })
  return loginPromise
}

/** 退出登录（仅在用户主动退出系统时调用） */
export function logoutTIM() {
  if (timInstance) {
    timInstance.logout()
    timInstance = null
    isLogin = false
    loginPromise = null
  }
}

/** 发送通用视频信令（接听/拒绝/挂断等） */
export function sendVideoSignal(toUserId, signal) {
  const tim = getTIM()
  if (!tim) throw new Error('TIM 未初始化')
  const message = tim.createCustomMessage({
    to: String(toUserId),
    conversationType: TencentCloudChat.TYPES.CONV_C2C,
    payload: {
      data: JSON.stringify(signal),
      description: 'video-call-signal'
    }
  })
  return tim.sendMessage(message)
}

/** 发送视频通话邀请（第三方/发起方使用） */
export function sendVideoCallInvite({ to, roomId, patientInfo, callerInfo, patientCode, diagRecordCode }) {
  const tim = getTIM()
  const message = tim.createCustomMessage({
    to: String(to),
    conversationType: TencentCloudChat.TYPES.CONV_C2C,
    payload: {
      data: JSON.stringify({
        type: 'VIDEO_CALL_INVITE',
        roomId,
        patientCode,
        diagRecordCode,
        patientInfo,
        callerInfo,
        from: tim.getMyUserID() || ''
      }),
      description: '视频通话邀请'
    }
  })
  return tim.sendMessage(message)
}
